import React, { useRef } from 'react';
import { Line, LineChart as RechartsLineChart, XAxis, YAxis, CartesianGrid } from 'recharts';
import { chartDefaults, ISimpleLineChart } from '../SimpleChartEngine/types';
import { ChartContainer, ChartLegend, ChartTooltip } from '@/components/ui/chart';
import { AIChartEngineCustomLegendContent, generateChartParams } from '../SimpleChartEngine/SimpleChartEngine';
import { SimpleChartCardWrapper } from './SimpleChartCardWrapper';
import { SimpleChartTooltip } from './SimpleChartTooltip';
import { CustomDot, CustomActiveDot } from './CustomDot';


export const SimpleLineChart: React.FC<ISimpleLineChart> = (props) => {
  const { data, xAxisKey = chartDefaults.xAxisKey } = props;
  const chartContainerRef = useRef<HTMLDivElement>(null) as React.RefObject<HTMLDivElement>;

  const { chartDataKeys, chartColors, chartConfig, chartOptions } = generateChartParams(props);

  return (
    <SimpleChartCardWrapper {...props}>
      <ChartContainer
        ref={chartContainerRef}
        config={chartConfig}
        style={{ maxHeight: chartOptions.maxHeight, minHeight: chartOptions.minHeight, width: '100%', marginTop: '10px' }}
      >
        <RechartsLineChart data={data}>
          {
            chartOptions.showGrid &&
            <CartesianGrid
              strokeDasharray="3 3"
              stroke="hsl(var(--border))"
            />
          }

          <XAxis
            dataKey={xAxisKey}
            stroke="hsl(var(--muted-foreground))"
            fontSize={12}
          />

          <YAxis
            stroke="hsl(var(--muted-foreground))"
            fontSize={12}
            tickFormatter={chartOptions.yAxisTickFormatter}
            width={chartOptions.yAxisWidth}
          />

          {chartOptions.showLegend && (
            <ChartLegend
              content={
                <AIChartEngineCustomLegendContent
                  config={chartConfig} />
              } />
          )}

          <ChartTooltip
            content={(props) => (
              <SimpleChartTooltip
                {...props}
                options={chartOptions}
                config={chartConfig}
                chartContainerRef={chartContainerRef}
              />
            )}
          />

          {chartDataKeys.map((key, index) => (
            <Line
              key={key}
              type="monotone"
              dataKey={key}
              stroke={chartColors[index]}
              strokeWidth={2}
              dot={chartOptions?.showDots ? <CustomDot fillColor={chartColors[index]} /> : false}
              activeDot={<CustomActiveDot fillColor={chartColors[index]} />}
              fill={chartOptions?.showArea ? chartColors[index] : 'transparent'}
              fillOpacity={chartOptions?.showArea ? 0.1 : 1}
            />
          ))}
        </RechartsLineChart>
      </ChartContainer>
    </SimpleChartCardWrapper>
  );
};
